document.addEventListener("DOMContentLoaded", () => {
let resizeObserverTimeout;

const resizeObserver = new ResizeObserver(entries => {
    for (let entry of entries) {
        clearTimeout(resizeObserverTimeout);
        resizeObserverTimeout = setTimeout(() => {
            window.dispatchEvent(new Event("resizePage"));
        }, 300)
    }
});

resizeObserver.observe(document.body);


});
document.addEventListener('DOMContentLoaded', () => {
  const helpList = document.querySelector('.help-list');

  // Открытие нужного help-body
  document.body.addEventListener('click', (e) => {
    const helpItem = e.target.closest('[class*="help-"]');
    if (!helpItem || helpItem.className.includes('-body')) return;

    const helpClass = [...helpItem.classList].find(cls => /^help-\d+$/.test(cls));
    if (!helpClass) return;

    const helpBody = document.querySelector(`.${helpClass}-body`);
    if (!helpBody) return;

    helpList?.style && (helpList.style.display = 'none');
    helpBody.style.display = 'block';
  });

  // Возврат назад
  document.body.addEventListener('click', (e) => {
    const backBtn = e.target.closest('.help-back');
    if (!backBtn) return;
    document.querySelectorAll('.help-body-hidden').forEach( i => {
      i.style.display = 'none';
    })
    // Находим ближайший .help-*-body, в котором находится кнопка
    // const currentBody = backBtn.closest('[class$="-body"]');
    // if (currentBody) currentBody.style.display = 'none';

    helpList?.style && (helpList.style.display = 'block');
  });


  // ANCHOR
  
});


